import { DEV_JWT_KEY } from "@/shared/helper/constants.helper";
import { isDevelopment } from "@/shared/helper/environment.helper";
import { hasAuthenticatedUser } from "./hasAuthenticatedUser.helper";

export const isAuthenticated = async () => {
  const hasUserStored = await hasAuthenticatedUser();
  if (hasUserStored) return true;

  // If there is no user stored and we are in development mode, we need to authenticate the user with the stored test-user-token from the local storage
  const token = localStorage.getItem(DEV_JWT_KEY);
  if (isDevelopment) return Boolean(token);

  return false;
};
